module.exports = __webpack_public_path__ + "static/media/Vinohradka.e8b03267.md";